// <input type="hidden" name="s" value="@(Request.QueryString["s"])" />
import defineComponent from 'flight';
import ItemsClickStorage from 'static/script/app/models/items-click-storage';
import memberInfo from 'static/script/app/data/member-info';
import location from 'static/script/utils/location';
import history from 'static/script/utils/history';

function MinimalRouter() {
    this.defineHashRoute = function (route, fn) {
        let re = new RegExp('^#' + route);
        let result = re.exec(location.hash);
        if (result) {
            fn.apply(this, result.slice(1));
        }
    };
}

function BiddingModal() {
    this._storage = new ItemsClickStorage();

    this.defaultAttrs({
        submitForm: 'form[data-bidding-modal]',
        openLink: 'a[data-bidding-modal]'
    });

    this._onSubmitForm = function (evt) {
        let target = $(evt.target),
            form = target,
            action = form.attr('action'),
            method = form.attr('method'),
            data = form.serialize();

        if (method === 'post') {
            this._postToModal(evt, action, data);
        } else {
            this._getToModal(evt, action + '?' + data);
        }
    };

    this._onClickLink = function (evt, target) {
        let $target = $(target.el),
            href = $target.attr('href');
        this._getToModal(evt, href);

    };

    this._postToModal = function (evt, href, data) {
        if (!memberInfo.isLoggedIn) {
            return;
        }
        evt.preventDefault();
        this.trigger(document, 'data:navigation:post-to-modal', {
            href: href,
            data: data,
            reloadAfterModalClose: true,
            element: $(evt.target).find('[type=submit]')
        });
    };

    this._getToModal = function (evt, href) {
        evt.preventDefault();
        if (!memberInfo.isLoggedIn) {
            this._login(href);
        } else {
            this.trigger(document, 'data:navigation:get-to-modal', {
                href: href
            });
        }
    };

    this._login = function (returnToModalHref) {
        let destination = location.protocol + '//' + location.host + location.pathname + location.search + '#' + 'bidding=' + returnToModalHref;
        this.trigger(document, 'ui:login:show', { destination: encodeURIComponent(destination) });
    };

    this._openModalFromHref = function (href) {

        if (!memberInfo.isLoggedIn) {
            this._removeHash();
            return;
        }

        if (!this._verifyModalLinkExistsOnPage(href)) {
            this._removeHash();
            return;
        }

        this.on(document, 'ui:body-container:on-modal-close', this._removeHash);
        this.trigger(document, 'data:navigation:get-to-modal', { href: href });
    };

    this._verifyModalLinkExistsOnPage = function (href) {
        let path = href.split('?')[0];

        let sourceElement = this.$node.find('a[href^="' + path + '"], form[method=get][action^="' + path + '"]');
        return sourceElement.length > 0;
    };

    this._removeHash = function () {
        history.replaceState({}, window.title, location.pathname + location.search);
    };

    this._init = function () {
        let storage = this._storage,
            itemId,
            searchId;

        this.select('submitForm').each(function () {
            itemId = $(this).find('[name=id]').val();

            if (itemId) {
                searchId = storage.getSearchId(itemId);

                if (searchId) {
                    $('<input>').attr({
                        type: 'hidden',
                        name: 's',
                        value: searchId
                    }).appendTo($(this));
                }
            }
        });
    };


    this.after('initialize', function () {
        this._init();

        this.on('click', {
            openLink: this._onClickLink
        });
        this.on('submit', {
            submitForm: this._onSubmitForm
        });
        this.defineHashRoute('bidding=(.*)', this._openModalFromHref);
    });
}

module.exports = defineComponent.component(BiddingModal, MinimalRouter);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/view-item/bidding-modal.js